import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { FormCreateRequest } from "@colab/shared";

export type CreateFormResponse = { id: string; slug: string };

// POST /api/admin/forms
//
// Replaces /app/admin/forms/_actions.ts::createFormAction. The worker derives
// the slug from the name and retries once on a collision. The caller routes
// to /admin/forms/[id]/edit on success.
export function useCreateForm() {
  const queryClient = useQueryClient();
  return useMutation<CreateFormResponse, ApiClientError, FormCreateRequest>({
    mutationFn: (input) =>
      apiFetch<CreateFormResponse>("/admin/forms", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.adminForms.list() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to create form");
    },
  });
}
